import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../../../..";
import { useAFLColumns, useAFLRequests } from "../../../hooks";
import { AFLType } from "../../../models";
import { Routes } from "../../../../../../../AppRoutes";
import { UserManual, Icon, Box, Table } from "../../../../../../../components";
import CreateRequestButton from "../../../../../components/CreateRequestButton";

export const SuspendContractList = withProcedureWraper(() => {
  const history = useHistory();
  const { columns, columns2 } = useAFLColumns();
  const { isLoading, myRequests, myRequestsNeedApproval, completedMyRequests } = useAFLRequests({
    department: ["DAD"],
    aflType: AFLType.AFLSuspendContract,
  });

  const redirectToDetailPage = (requestId: string) => {
    history.push(`${Routes.suspendContractDADPage.path}/${requestId}`);
  };

  const redirectToCreatePage = () => {
    history.push(Routes.createSuspendContractDADPage.path);
  };

  return (
    <div className="pd15">
      <UserManual
        icon={<Icon.DocumentWrite />}
        title="ĐƠN XIN TẠM HOÃN HỢP ĐỒNG LAO ĐỘNG"
        guideLink="https://drive.google.com/file/d/1vOHOmUrsCmr-LDcYWg7y_H8e4oirD-DW/view"
      />
      <Box title="Yêu cầu đã duyệt" titleRight={<CreateRequestButton onClick={redirectToCreatePage} />}>
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={completedMyRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Yêu cầu cần duyệt">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={myRequestsNeedApproval}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Tất cả yêu cầu">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns}
          dataSource={myRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
    </div>
  );
});
